module.exports = __webpack_public_path__ + "src/img/artist/artistpage9.svg?121f25ab981f61c1a061f5cc9c1f2d22";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage9.svg
// module id = 127
// module chunks = 0